import React, { useEffect, useState } from 'react';
import {
    Grid, Typography, Paper, Button, Divider, Dialog, DialogTitle,
    DialogContent, TextField, DialogActions
} from '@material-ui/core';
import firebase from 'firebase/app';
import { useSelector } from 'react-redux';
import { modalidadCateogoriaNameByCode } from "../../../../services/utils";

const DetalleParticipante = ({ participanteId, itemAEntregar, eventoIndex, onEntregado, perfil }) => {
    const [modalAbierto, setModalAbierto] = useState(false);
    const [nombrePersona, setNombrePersona] = useState('');
    const [showDetail, setShowDetail] = useState(false);

    const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
    const userID = useSelector((state) => state.atlete.userID);
    const eventSubEventsRegistry = useSelector((state) => state.events.eventSubEventsRegistry);
    const participante = useSelector((state) => state.registry.eventParticipants[participanteId]);

    const extraData = useSelector(
        (state) => state.registry.registryConfiguration?.configuracion?.entregaKits?.extraData || []
    );

    const grupoFormularios = useSelector(
        (state) => state.registry.registryConfiguration?.gruposFormularios || {}
    );

    const usuarioActual = atleteAccount;
    const IDCompetidor = userID;

    const itemYaEntregado = () => {
        const entregas = participante.entregaKit;
        if (!entregas) return false;
        return Object.values(entregas).some((e) => e.item?.code === itemAEntregar.code);
    };

    const guardarEntrega = async (recibeAtleta = true, nombreManual = '') => {
        const recibePersona = recibeAtleta
            ? `${participante.nombres} ${participante.apellidos}`
            : nombreManual;

        if (!recibePersona) return alert("Nombre requerido para continuar");

        const timestamp = new Date().getTime();

        const entrega = {
            iduser: IDCompetidor,
            nombresUser: usuarioActual.nombres,
            apellidosUser: usuarioActual.apellidos,
            date: timestamp,
            item: itemAEntregar,
            recibeAtleta,
            recibePersona,
            scanner: participante._scanner || false,
            itemFormData: {}
        };

        const updates = {};
        updates[`eventosCompletos/${eventoIndex}/inscritos/listadoInscritos/${participanteId}/entregaKit/${timestamp}_ts`] = entrega;

        const changesRegistry = {
            ...participante.changesRegistry,
            [timestamp + '_ts']: {
                iduser: IDCompetidor,
                apellidosUser: usuarioActual.apellidos,
                nombresUser: usuarioActual.nombres,
                action: 12,
                description: `Entrega de kit: ${itemAEntregar.name}`,
                date: timestamp
            }
        };

        updates[`eventosCompletos/${eventoIndex}/inscritos/listadoInscritos/${participanteId}/changesRegistry`] = changesRegistry;

        await firebase.database().ref().update(updates);
    };

    const modalidadInfo = eventSubEventsRegistry?.[`modalidad_${participante.modalidad}`] || {};
    const categoriaInfo = modalidadInfo.ramaCat?.[`rama_${participante.rama}`]?.categorias?.[`categoria_${participante.categoria}`] || {};
    const orderItems = Object.values(participante.order || {});
    const total = orderItems.reduce((acc, item) => acc + (item.quantity * item.unit_price), 0);

    // 🔁 Aplana campos con iDCampo
    const obtenerCamposConID = (grupoFormularios) => {
        const camposUnicos = {};
        Object.values(grupoFormularios || {}).forEach((grupo) => {
            grupo.forEach((campo) => {
                if (campo.iDCampo && !camposUnicos[campo.iDCampo]) {
                    camposUnicos[campo.iDCampo] = campo;
                }
            });
        });
        return camposUnicos;
    };

    const camposUnificados = obtenerCamposConID(grupoFormularios);

    const traducirValor = (campo, valor) => {
        if (campo.tipoCampo?.toLowerCase() === 'select' && Array.isArray(campo.valor)) {
            const encontrado = campo.valor.find((v) => v.valor === valor);
            return encontrado ? encontrado.texto : valor || 'No proporcionado';
        }
        return valor || 'No proporcionado';
    };

    return (
        <Paper style={{ padding: 10, marginTop: 5 }}>
            <Grid container spacing={2}>
                <Grid item xs={8}>
                    <Typography variant="subtitle1" align="center">Nombre:</Typography>
                    <Typography variant="h4" align="center">
                        {participante.nombres} {participante.apellidos}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="subtitle1" align="center">Número: </Typography>
                    <Typography variant="h2" align="center">
                        {participante.numero}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Paper style={{ padding: 10 }}>
                        <Typography variant="subtitle1" align="center" style={{ fontWeight: 'bold' }}>
                            Datos de inscripción
                        </Typography>
                        <Typography variant="subtitle1">
                            🏁 Modalidad: {modalidadInfo.descripcionModalidad}
                            {" "}- 👤 Rama: {participante.rama}
                            {" "}- 🏷️ Categoría: {categoriaInfo.nombreCategoria}
                        </Typography>
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Paper style={{ padding: 10 }}>
                        {participante.order && Object.values(participante.order).length > 0 && (
                            <Grid container spacing={2}>
                                {showDetail && (
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" style={{ textAlign: "center", fontWeight: 'bold', marginTop: 16 }}>
                                            Detalle de la orden
                                        </Typography>
                                        {Object.values(participante.order).map((item, index) => (
                                            <Grid container spacing={1} key={index} alignItems="center">
                                                <Grid item xs={8}>
                                                    <Typography variant="body1">
                                                        • {item.name}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {item.description}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Typography variant="body2" align="right">
                                                        {item.quantity} x {item.unit_price}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Typography variant="body2" align="right">
                                                        {item.quantity * item.unit_price}
                                                    </Typography>
                                                </Grid>
                                                <Divider style={{ margin: '16px 0', color: "grey" }} />
                                            </Grid>
                                        ))}
                                    </Grid>
                                )}
                                <Grid item xs={9}>
                                    <Typography variant="h4" style={{ textAlign: "center", fontWeight: 'bold', marginTop: 16 }}>
                                        Total pagado: {total}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Button
                                        variant="contained"
                                        onClick={() => setShowDetail(!showDetail)}
                                        style={{ fontWeight: 'bold', marginTop: 16 }}
                                    >
                                        {showDetail ? 'Ocultar' : 'Ver Detalle'}
                                    </Button>
                                </Grid>
                            </Grid>
                        )}
                    </Paper>
                </Grid>

                {/* Campos adicionales configurados */}
                {extraData.length > 0 && (
                    <Grid item xs={12}>
                        <Paper style={{ padding: 10 }}>
                            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: 8 }}>
                                Información adicional del atleta
                            </Typography>
                            {extraData.map((idCampo) => {
                                const campo = camposUnificados[idCampo];
                                const valor = participante[idCampo];
                                return (
                                    <Typography key={idCampo} variant="h6">
                                        {campo?.etiqueta || idCampo}: <strong>{traducirValor(campo, valor)}</strong>
                                    </Typography>
                                );
                            })}
                        </Paper>
                    </Grid>
                )}

                <Grid item xs={12}>
                    <Typography variant="h6" align="center">
                        Entregar <strong>{itemAEntregar.name}</strong> a:
                    </Typography>
                </Grid>

                <Grid item xs={6}>
                    <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        onClick={() => setModalAbierto(true)}
                        disabled={itemYaEntregado()}
                        style={{ height: 100, fontSize: 20 }}
                    >
                        A otra persona
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => guardarEntrega(true)}
                        disabled={itemYaEntregado()}
                        style={{ height: 100, fontSize: 20 }}
                    >
                        Al atleta
                    </Button>
                </Grid>

                {itemYaEntregado() && (
                    <>
                        <Grid item xs={12}>
                            <Paper style={{ padding: 12, backgroundColor: '#ef4123' }}>
                                <Typography variant="h5" align="center" style={{ color: '#fff', fontWeight: 'bold' }}>
                                    ✅ Este kit ya fue ENTREGADO
                                </Typography>
                            </Paper>
                            <Divider style={{ margin: '16px 0' }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                Historial de entregas de este kit
                            </Typography>
                            {Object.entries(participante.entregaKit)
                                .filter(([_, e]) => e.item?.code === itemAEntregar.code)
                                .map(([key, entrega]) => (
                                    <Paper
                                        key={key}
                                        elevation={2}
                                        style={{
                                            padding: 12,
                                            marginTop: 8,
                                            backgroundColor: '#f8f9fa',
                                            borderLeft: '4px solid #28a745',
                                        }}
                                    >
                                        <Typography variant="body2">
                                            📅 <strong>Fecha:</strong> {new Date(entrega.date).toLocaleString()}
                                        </Typography>
                                        <Typography variant="body2">
                                            🙋‍♂️ <strong>Recibe:</strong> {entrega.recibeAtleta ? 'El atleta' : entrega.recibePersona || 'N/A'}
                                        </Typography>
                                        <Typography variant="body2">
                                            👤 <strong>Entregado por:</strong> {entrega.nombresUser} {entrega.apellidosUser}
                                        </Typography>
                                        {(perfil === "MasterOrganizador" || perfil === "master") && (
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                color="secondary"
                                                style={{ marginTop: 8 }}
                                                onClick={async () => {
                                                    const confirmar = window.confirm('¿Estás seguro que deseas deshacer esta entrega?');
                                                    if (!confirmar) return;

                                                    await firebase.database().ref(`eventosCompletos/${eventoIndex}/inscritos/listadoInscritos/${participanteId}/entregaKit/${key}`).remove();
                                                    await firebase.database().ref(`eventosCompletos/${eventoIndex}/inscritos/listadoInscritos/${participanteId}/changesRegistry/${key}`).remove();
                                                }}
                                            >
                                                Deshacer entrega
                                            </Button>
                                        )}
                                    </Paper>
                                ))}
                        </Grid>
                    </>
                )}
            </Grid>

            <Dialog open={modalAbierto} onClose={() => setModalAbierto(false)}>
                <div style={{ padding: 30 }}>
                    <DialogTitle>¿Quién recibe el kit?</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            fullWidth
                            label="Nombre de la persona"
                            value={nombrePersona}
                            onChange={(e) => setNombrePersona(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setModalAbierto(false)} color="default">Cancelar</Button>
                        <Button
                            onClick={() => {
                                guardarEntrega(false, nombrePersona);
                                setModalAbierto(false);
                            }}
                            color="primary"
                        >
                            Confirmar Entrega
                        </Button>
                    </DialogActions>
                </div>
            </Dialog>
        </Paper>
    );
};

export default DetalleParticipante;
